import { createContext } from "react";
const MenuContext = createContext(null);
export {
  MenuContext
};
//# sourceMappingURL=MenuContext.js.map
